export const AppEnvironment = {
  Dev: 'development',
  Staging: 'staging',
  Production: 'production',
};

export default function useEnvironment() {
  return {
    isProduction: import.meta.env.VITE_MODE === AppEnvironment.Production,
    isStaging: import.meta.env.VITE_MODE === AppEnvironment.Staging,
    isDev: import.meta.env.VITE_MODE === AppEnvironment.Dev,
  };
}
